import  { Suspense, useEffect } from 'react';
import { AppRoutes } from './routes/AppRoutes';
import { Loader } from './components/common/Loader';
import { useContentService } from './services/contentService';
import { useAppSelector, useAppDispatch } from './store/hooks';
import { fetchTheme } from './store/slices/themeSlice';
import { Helmet } from 'react-helmet-async';

function App() {
  const dispatch = useAppDispatch();

  const { loadContent } = useContentService();
  const loading = useAppSelector((state) => state.content.loading);

  // ✅ Load content + theme at app start
  useEffect(() => {
    loadContent();
    dispatch(fetchTheme());
  }, [loadContent, dispatch]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      {/* ✅ GLOBAL SEO (Fallback) */}
      <Helmet>
        <title>Thalvora Exports</title>
        <meta
          name="description"
          content="Leading export company providing high quality products worldwide."
        />
        <meta name="robots" content="index, follow" />

        {/* Default Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Thalvora Exports" />
        <meta
          property="og:description"
          content="Trusted global export partner delivering quality products."
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      {/* Routes */}
      <Suspense fallback={<Loader />}>
        <AppRoutes />
      </Suspense>
    </>
  );
}

export default App;